module.exports = __webpack_public_path__ + "img/1502736832.921b0459.jpg";